exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._25YdPIjQ_v5INm-m8P7AdN{white-space:nowrap;color:\"[theme:redDark, default:#a80000]\";font-weight:400}html[dir=ltr] ._1aPP3UEryDDp1R9vR2u5Gm{margin-right:10px}html[dir=rtl] ._1aPP3UEryDDp1R9vR2u5Gm{margin-left:10px}", ""]);

// exports
exports.locals = {
	"couponRow": "_25YdPIjQ_v5INm-m8P7AdN",
	"icon": "_1aPP3UEryDDp1R9vR2u5Gm"
};